// When a leg maps a dedicated Country Code column, repeating that code inside the Free
// Address is redundant. Only the leading and trailing tokens count: those are the only
// positions the resolver inspects (docs/freeaddress.md, "Constraint for Multi-Value Cells"),
// and a code fused into a longer word belongs to that word rather than being a repeat —
// INBOM is the UN/LOCODE for Mumbai, not 'IN' twice.

export const duplicateCountryCodeIssue = (countryCode: string): string =>
  `Duplicate country code detected — '${countryCode.trim()}' is already supplied by the mapped Country Code column`;

const isLetter = (char: string | undefined): boolean => !!char && /[a-z]/.test(char);

export const hasIsolatedCountryCode = (freeAddress: string, countryCode: string): boolean => {
  const code = countryCode.trim().toLowerCase();
  const address = freeAddress.trim().toLowerCase();
  // ISO 3166-1 alpha-2 only; anything shorter can't be a country code.
  if (code.length < 2 || address.length < code.length) return false;

  const startsIsolated = address.startsWith(code) && !isLetter(address[code.length]);
  const endsIsolated = address.endsWith(code) && !isLetter(address[address.length - code.length - 1]);
  return startsIsolated || endsIsolated;
};
